/* eslint-disable @typescript-eslint/no-explicit-any */
import { Method as axiosMethod } from 'axios';

export type Headers = Record<string, string>;
export type Method = axiosMethod;
export type SubscriptionKey = Record<Workflow, string>;
export type WFPaths = Record<Workflow, string>;
export type DynamicData = Record<string, any> | null | undefined;
export type RecordList = { [x: string]: any };

export enum WorkflowTypes {
  INDIVIDUAL = 'individualwf',
  METADATA = 'metadatawf',
  MEMBER = 'memberwf',
  ORGANIZATION = 'organizationwf',
  CONFERENCE = 'conferencewf',
  AUTHORIZER = 'authorizerwf',
}
export enum LogLevel {
  Debug = 'debug',
  Error = 'error',
  Info = 'info',
  Warn = 'warn',
}
export type Workflow =
  | 'individualwf'
  | 'metadatawf'
  | 'memberwf'
  | 'organizationwf'
  | 'conferencewf'
  | 'authorizerwf';

export enum FieldType {
  Date = 'Date',
  Number = 'Number',
  Options = 'Options',
  String = 'String',
}

export enum FieldCharSet {
  OnlyDigits = 'OnlyDigits',
  /** DIS regex: `/^[\\ -\\ɏ]*$/`. */
  OnlyLatin = 'OnlyLatin',
}

export namespace DOMINO_INDV {
  export type BasicSearchIndividual = {
    dominoId: string;
    disIndividualId?: string;
    riIndividualId: string;
    netForumKey: string;
  };
}
export namespace DOMINO_METADATA {
  export type DominoMetaConfig = { [metaKey: string]: string | boolean };
}

export namespace DOMINO_IAM {
  export type AccessLevel =
    | 'No Permission'
    | 'Limited Viewer'
    | 'Viewer'
    | 'Contributor'
    | 'Manager';
}

export namespace DOMINO_UI {
  export enum AccessLevel {
    /** Can edit, but some fields are restricted. */
    Contributor = 'Contributor',
    LimitedViewer = 'LimitedViewer',
    /** Can edit everything. */
    Manager = 'Manager',
    NoPermission = 'NoPermission',
    Viewer = 'Viewer',
  }
}

export type District = {
  DominoId: string;
  Name: string;
  Base: null;
  Type: string;
  riClubId: number;
  riDistrictId: number;
  districtLegalName: string;
};
export type DominoClub = {
  page: 1;
  pageSize: 10;
  totalCount: 1;
  _embedded: {
    clubs: [
      {
        district: District;
      }
    ];
  };
};

export enum StatusCode {
  UserNotAuthenticated = 'UserNotAuthenticated',
  SessionValidated = 'SessionValidated',
}

export type LeadershipRole = {
  id: string;
  value: string;
  detail: {
    organizationType: string;
    termLength: number;
    termOfAccessBefore: number;
    termOfAccessAfter: number;
    startDate: string;
    endDate: string | null;
    mustBeMembership: string[];
    isOfficer: boolean;
    restrictPerOrganizationFlag: boolean;
    useFlag: boolean;
    officerManagement: string;
  };
};
